import React from "react";
import { ActiveUserIcon, NewSignupIcon, TotalBooking } from "../../constant";
import UserStatsCard from "../UserSatsCard";
import classes from "./UserStats.module.css";
const UserStats = ({ data,period}) => {
  console.log("period [][]",period);
  return (
    <div className={classes.wrapper}>
      <div className={classes.userStatsContainer}>
        
          <UserStatsCard number={data?.totalUsers} title={"New sign ups"} icon={<NewSignupIcon />} period={period} />
        
       
          <UserStatsCard number={data?.activeUsers} title={"Active Users"} icon={<ActiveUserIcon />} period={period} />
      
        
          <UserStatsCard number={data?.totalBookings} title={"Total Bookings"} icon={<TotalBooking />} period={period} />
        
      </div>
    </div>
  );
};

export default UserStats;
